import { render, staticRenderFns } from "./ChecklistTab.vue?vue&type=template&id=ec7ddca6&"
import script from "./ChecklistTab.vue?vue&type=script&lang=js&"
export * from "./ChecklistTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec7ddca6')) {
      api.createRecord('ec7ddca6', component.options)
    } else {
      api.reload('ec7ddca6', component.options)
    }
    module.hot.accept("./ChecklistTab.vue?vue&type=template&id=ec7ddca6&", function () {
      api.rerender('ec7ddca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/tabs/ChecklistTab.vue"
export default component.exports